module.exports = __webpack_public_path__ + "static/media/sprite_exp_card_t2.68961cf0.png";